import { createAction, props } from '@ngrx/store';
import { MenuItem } from '../sidebar/menu.model';

// Trigger a menu fetch for the current role
export const loadMenu = createAction(
  '[Menu] Load Menu',
  props<{ role: string }>()
);

export const loadMenuSuccess = createAction(
  '[Menu] Load Menu Success',
  props<{ menu: MenuItem[] }>()
);

export const loadMenuFailure = createAction(
  '[Menu] Load Menu Failure',
  props<{ error: any }>()
);
